<template>
    <div id="businessAdmin" class="app-inner">
         <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addBusiness">
        新增账号
      </div>
         </div>
       <div class="p-tit-c">
        <div class="businessList-filter">
              <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">管理员ID：</div>
          <div class="el-select1">
            <el-input placeholder="管理员ID" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">管理员姓名：</div>
          <div class="el-select1">
          <el-input placeholder="管理员姓名" v-model="search1" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
             <div class="label">企业管理员账号：</div>
          <div class="el-select1">
          <el-input placeholder="企业管理员账号" v-model="search4" clearable> </el-input>
          </div>
          </div>
      </div>
      <div class="businessList-filter-list  flex align-cen">
                  <div class="fl-le flex align-cen">
          <div class="label">关联公司ID：</div>
          <div class="el-select1">
          <el-input placeholder="关联公司ID" v-model="search2" clearable> </el-input>
          </div>
         </div>
         <div class="fl-rt flex align-cen">
          <div class="label">关联公司名称：</div>
          <div class="el-select1">
          <el-input placeholder="关联公司名称" v-model="search3" clearable> </el-input>
          </div>
         </div>
      </div>
       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
          导出
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
        </div>
       </div>
       <div class="businessList-container">
        <!-- 表格 -->
            <div class="businessList-container-table">
                  <el-table
                    ref="multipleTable"
                    :data="itemList"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                    :row-key="getRowKeyOfTarget"
                    @selection-change="handleSelectionChange"
                    id='mytable'
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                     <el-table-column type="selection" width="55" reserve-selection> </el-table-column>
                       <el-table-column prop="id" label="管理员ID" align="center">
                        </el-table-column>
                         <el-table-column prop="userName" label="管理员姓名" align="center">
                        </el-table-column>
                         <el-table-column prop="loginName" label="管理员账号" align="center">
                        </el-table-column>
                         <el-table-column  label="关联微信号" align="center">
                            <template slot-scope="scope">
                                <div> {{scope.row.wechatAccount || '暂未关联'}}</div>
                            </template>
                        </el-table-column>
                          <el-table-column  label="关联企业" align="center">
                            <template slot-scope="scope">
                              <div  @click.stop="detail(scope.row)" style="cursor: pointer;color:red">
                                {{scope.row.businessNum}}家
                              </div>
                            </template>
                        </el-table-column>
                         <el-table-column label="操作" align="center"
                          fixed="right"
                         >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                 @click.stop="editPro(scope.row)"
                >编辑</el-button
              >
               <el-button
                type="text"
                size="small"
                 @click.stop="detail(scope.row)"
                >查看详情</el-button
              >
               <el-popover width="160" :ref="`popover-${scope.$index}`" class="ma10">
                    <p style="padding:10px 0"><i class="icon-al-delete-fill" style="color:#F56C6C"></i>确认删除此项吗？</p>
                     <span style="font-size:12px;padding-bottom:10px;display:block">删除不可恢复，请谨慎删除。</span>
                    <div style="text-align: right; margin: 0">
                        <el-button type="text" size="mini" @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">
                        取消
                        </el-button>
                        <el-button type="danger" size="mini"  @click="deletPro(scope.row,scope.$index)">确定</el-button>
                    </div>
                   <el-button type="text" size="small"  slot="reference" style="color:red">删除</el-button>
                    </el-popover>
              <!-- <el-button
                type="text"
                size="small"
                style="color:red"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
                  </el-table>
                  <!-- 分页 -->
                    <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
            </div>
       </div>
    </div>
    </div>
</template>
<script>
import {getbusinessAccountList} from "@/api/index/index"  //企业管理员列表
import {delbusinessAdmin} from "@/api/index/index"  //删除企业管理员列表
import exportExcel from '../../utils/exportExcel.js' //导出数据公共方法
export default {
    name:'businessAdmin',
     data: () => {
        return {
            search:'',
            search1:'',
            search2:'',
            search3:'',
            search4:'',
            multipleSelection:[],
             totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
            itemList:[
            ],
        }
     },
     activated(){
  this.gethisInfo()
},
    //  created(){
    //     this.gethisInfo()
    //  },

     methods: {
      // 删除企业管理员
          deletPro(data,index){
           delbusinessAdmin({
                id:data.id
              })
            .then(res => {
                if(res.code == 0){
                this.$message({
                type: 'success',
                message: '删除成功!'
             });
             this.currentPage = 1
            this.gethisInfo()
            }else{
                 this.$message.error(res.msg); 
            }
            this.$refs[`popover-${index}`].doClose()
            })
            .catch(err => {
            })
    },
           // 获取列表
        gethisInfo(){
            let params = {
                id:this.search,
                userName:this.search1,
                businessId:this.search2,
                businessName:this.search3,
                loginName:this.search4,
                source:'',
                current: this.currentPage,
                size:this.PageSize,
            }
            getbusinessAccountList(params)
            .then(res => {
              this.itemList = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
        // 新增
        addBusiness(){
            this.$router.push("/editAdminbuss")
        },
         // 编辑
        editPro(data){
           this.$router.push({
            name: "editAdminbuss",
            query:{
                id:data.id
            }
           })
        },
         // 打开企业管理员详情
        detail(data){
            this.$router.push({
            name: "adminDetail",
            query:{
                id:data.id,
                type:1
            }
           })
        },
        // 搜索
        searchList(){
             if(this.search || this.search1 || this.search2 || this.search3 || this.search4){
                this.currentPage = 1
                this.gethisInfo()
            }else{
               this.$message.warning('请输入查询条件'); 
            }
        },
        // 导出
            exportExcel(val){ 
            if(val.length !=0){
            let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '管理员ID':val[item].id, 
              '管理员姓名':val[item].userName, 
              '管理员账号':val[item].loginName,
              '关联微信号':val[item].wechatAccount || '暂未关联',
              '关联企业':val[item].businessNum, 
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
            }else{
               this.$message.error('未选择导出数据'); 
            }
          },
        // 重置
        reset(){
            this.search = ""
            this.search1 = ""
            this.search2 = ""
            this.search3 = ""
            this.search4 = ""
            this.currentPage = 1
            this.gethisInfo()
        },
         getRowKeyOfTarget(row) {
            return row.id
        },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
       handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
     }
}
</script>
<style lang="scss" scoped>
#businessAdmin{
    padding: 0 20px;
      .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
    .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .ma10{
        margin-left: 10px;
      }
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
}
::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
}
</style>